import React from 'react';
import styles from './index.module.scss';

function OrderSectionPopoverContent({ text }) {
  return <div className={styles.content} data-palette="OrderSectionPopoverContent">{text}</div>;
}

export default OrderSectionPopoverContent;
